module.exports = __webpack_public_path__ + "img/gb-nir.7a23a0d7.svg";